import React from 'react';
import { Link } from 'react-router-dom';
import { usePageTitle } from '../hooks/usePageTitle';
import { FullPageMessage } from '../components/ui';

const NotFound: React.FC = () => {
  usePageTitle('Seite nicht gefunden');

  return (
    <FullPageMessage
      icon={
        <svg className="h-8 w-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z" />
        </svg>
      }
      iconBg="var(--accent-warm)"
      title="404"
      description="Hier gibt es nichts zu sehen. Vielleicht ist der Link veraltet oder die Adresse hat sich vertippt."
      action={
        <Link
          to="/"
          className="btn-primary inline-flex items-center px-6 py-3 bg-brand-600 text-white font-semibold text-sm rounded-lg hover:bg-brand-700"
        >
          Zu den Events
        </Link>
      }
    />
  );
};

export default NotFound;
